import { render, staticRenderFns } from "./StepDiagnosticoServicio.vue?vue&type=template&id=95016bf0"
import script from "./StepDiagnosticoServicio.vue?vue&type=script&lang=js"
export * from "./StepDiagnosticoServicio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports